import { FreightMode } from '@freight-cbm/shared-types';
import { useAppStore } from '@/store/store';
import { ExpressionInput } from 'calc-controls';
import { CurrencySelect } from '@/components/shared/CurrencySelect';
import { Tooltip } from '@/components/shared/Tooltip';

interface CostInputPanelProps {
  mode: FreightMode;
}

export function CostInputPanel({ mode }: CostInputPanelProps) {
  const costInput = useAppStore((s) => s.costInput);
  const setRatePerKg = useAppStore((s) => s.setRatePerKg);
  const setRatePerCBM = useAppStore((s) => s.setRatePerCBM);
  const setRatePerRevenueTon = useAppStore((s) => s.setRatePerRevenueTon);
  const setCurrency = useAppStore((s) => s.setCurrency);

  return (
    <div className="section-divider" data-testid="cost-input-panel">
      <h3 className="section-title">Cost Input</h3>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: 'var(--space-3)',
        }}
      >
        {(mode === FreightMode.Air || mode === FreightMode.Courier) && (
          <ExpressionInput
            label="Rate per kg"
            value={costInput.ratePerKg}
            onChange={setRatePerKg}
            unit={costInput.currency}
            min={0}
            decimals={2}
          />
        )}
        {mode === FreightMode.OceanLCL && (
          <>
            <ExpressionInput
              label="Rate per CBM"
              value={costInput.ratePerCBM}
              onChange={setRatePerCBM}
              unit={costInput.currency}
              min={0}
              decimals={2}
            />
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--space-1)' }}>
              <ExpressionInput
                label="Rate per Revenue Ton"
                value={costInput.ratePerRevenueTon}
                onChange={setRatePerRevenueTon}
                unit={costInput.currency}
                min={0}
                decimals={2}
              />
              <Tooltip content="If set, overrides rate per CBM. Billed per revenue ton (W/M) — the greater of volume or weight.">
                <span style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-muted)', cursor: 'help', lineHeight: '2.5', whiteSpace: 'nowrap' }}>?</span>
              </Tooltip>
            </div>
          </>
        )}
        <CurrencySelect
          label="Currency"
          value={costInput.currency}
          onChange={setCurrency}
        />
      </div>
    </div>
  );
}
